import { createSlice } from '@reduxjs/toolkit';

import { initSucceeded } from '../../actions/cabinListActions';

// NB: This slice previously imported its action types from `comboListActionTypes` — combo-list's
//     module, not cabin-list's. It worked only because every view declared the same unprefixed
//     `INIT_SUCCESS = 'INIT_SUCCESS'` string, so the wrong import resolved to the right value.
//     Namespaced action types make that class of mistake an import error instead of a silent one.
const transportSlice = createSlice({
  name: 'transport',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initSucceeded, (_state, action) => action.payload.transport);
  },
});

export default transportSlice.reducer;
